import { render, staticRenderFns } from "./AlertIntern.vue?vue&type=template&id=567154ed"
import script from "./AlertIntern.vue?vue&type=script&lang=js"
export * from "./AlertIntern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports